import { inject, Injectable, Type } from '@angular/core';
import { FpLoggerNoiseTabs } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/enums/fp-logger-noise-tabs.enum';
import { IFpLoggerNoiseData } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/interfaces/fp-logger-noise-data';
import { IFpLoggerNoiseTabConnectService } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/interfaces/fp-logger-noise-tab-connect-service';
import { FpLoggerNoiseCommentsComponent } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-comments/components/fp-logger-noise-comments/fp-logger-noise-comments.component';
import { FpLoggerNoiseCommentsMinimizedComponent } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-comments/components/fp-logger-noise-comments-minimized/fp-logger-noise-comments-minimized.component';
import { FpLoggerNoiseCommentsActionType } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-comments/services/fp-logger-noise-comments/fp-logger-noise-comments.actions';
import { FpLoggerNoiseCommentsStore } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-comments/services/fp-logger-noise-comments/fp-logger-noise-comments.store';
import { ILdLogger } from '@app/main/leak-detection/interfaces/ld-logger';
import { Observable } from 'rxjs';

@Injectable()
export class FpLoggerNoiseCommentsConnectService implements IFpLoggerNoiseTabConnectService {
  protected tabStore = inject(FpLoggerNoiseCommentsStore);
  public currentTab = FpLoggerNoiseTabs.Comments;

  public component: Type<unknown> = FpLoggerNoiseCommentsComponent;
  public minimizedComponent: Type<unknown> = FpLoggerNoiseCommentsMinimizedComponent;

  public localLoading(): Observable<boolean> {
    return this.tabStore.loading$;
  }

  public isActive(tab: FpLoggerNoiseTabs) {
    return this.currentTab === tab;
  }

  public initData(selectedDate: string, selectedData: ILdLogger) {
    this.tabStore.dispatch({
      type: FpLoggerNoiseCommentsActionType.GetData,
      date: selectedDate,
      popupMainData: this.toFpLoggerNoiseData(selectedData),
    });
  }

  public updateData(selectedDate: string, selectedData: ILdLogger) {
    this.tabStore.dispatch({
      type: FpLoggerNoiseCommentsActionType.GetData,
      date: selectedDate,
      popupMainData: this.toFpLoggerNoiseData(selectedData),
    });
  }

  private toFpLoggerNoiseData(data: ILdLogger): IFpLoggerNoiseData {
    return {
      loggerDeployment: data.deployment,
      loggerMeasurement: data.measurement,
    };
  }
}
